import axios from "axios";

// const SERVER_URL = `${process.env.REACT_APP_SITEURL}/auth`;
const SERVER_URL = `https://auth.umlang.com/auth`;

const handleJWT = async () => {
  try {
    let refreshToken = JSON.parse(localStorage.getItem("refreshToken"));
    let res = await axios.post(
      `${SERVER_URL}/api/v1/auth/login/getNewTokenCode`,
      { newTokenRequest: refreshToken, device:"web" }
    );
    if (res["data"] && res["data"]["token"]) {
      localStorage.setItem("token", JSON.stringify(res["data"]["token"]));
      return true;
    } else {
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("token");
      window.location.reload();
      return false;
    }
  } catch (error) {
    let runElse = false;
    if (error["response"]) {
      if (error["response"]["data"]) {
        if (error["response"]["data"]["message"]) {
          if (
            error["response"]["data"]["message"].includes(
              "No matching document found"
            )
          ) {
            return await handleJWT();
          } else runElse = true;
        } else runElse = true;
      } else runElse = true;
    } else runElse = true;
    if (runElse) {
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("token");
      window.location.reload();
      return false;
    }
  }
};

const rmStorageAndReload = () => {
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("token");
  window.location.reload();
};

export { handleJWT, rmStorageAndReload };
